import { Link } from 'react-router-dom';
import { siteInfo, animeCategories } from '@/mocks/animeData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-primary-400 whitespace-nowrap mb-4">
              <i className="ri-play-circle-fill text-2xl"></i>
              <span>{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">快速导航</h3>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><Link to="/category/guoman" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">国漫专区</Link></li>
              <li><Link to="/category/riman" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">日漫专区</Link></li>
              <li><Link to="/category/meiman" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">美漫专区</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">热门分类</h3>
            <ul className="space-y-2.5">
              {animeCategories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">联系我们</h3>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400 whitespace-nowrap">
                <i className="ri-mail-line text-primary-400"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400 whitespace-nowrap">
                <i className="ri-wechat-line text-primary-400"></i>
                {siteInfo.wechat}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400 whitespace-nowrap">
                <i className="ri-qq-line text-primary-400"></i>
                {siteInfo.qq}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站所有资源均来自互联网，仅供交流学习使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}